import {
  ChangeDetectorRef,
  Component,
  Inject,
  OnDestroy,
  OnInit,
} from '@angular/core';
import { Router } from '@angular/router';

import { Subject } from 'rxjs';
import { takeUntil } from 'rxjs/operators';

import { MwAuthService, MwUserService } from '@core/auth';
import { Config, ProfileMenuItem } from '@core/config';
import { MW_APP_CONFIG } from '@core/services';

import { SidebarId } from '../../layout.constants';
import { MwSidebarService } from '../sidebar/sidebar.service';
import { MwSidebarComponent } from './../sidebar/sidebar.component';
import { ProfileMenuBuilderService } from './profile-menu-builder.service';
import { MwProfileMenuDataService } from './profile-menu-data.service';
import { ProfileMenuEventsService } from './profile-menu-events.service';

@Component({
  selector: 'mw-profile-menu',
  templateUrl: 'profile-menu.component.html',
  styleUrls: ['./profile-menu.component.scss'],
  providers: [
    MwProfileMenuDataService,
    ProfileMenuBuilderService,
    ProfileMenuEventsService,
  ],
})
export class MwProfileMenuComponent implements OnInit, OnDestroy {
  static nextId = 0;
  readonly _id = MwProfileMenuComponent.nextId++;

  version = this.config.environment.version;

  private unsubscribeAll$ = new Subject<void>();
  private profileMenuSidebar: MwSidebarComponent;

  constructor(
    public readonly service: MwProfileMenuDataService,
    private readonly authService: MwAuthService,
    private readonly userService: MwUserService,
    private readonly sidebarService: MwSidebarService,
    private readonly menuBuilder: ProfileMenuBuilderService,
    private readonly eventsService: ProfileMenuEventsService,
    private readonly router: Router,
    private readonly changeDetectorRef: ChangeDetectorRef,
    @Inject(MW_APP_CONFIG) private readonly config: Config
  ) {}

  ngOnInit(): void {
    this.subscribeToProfileMenuSidebar();
    this.subscribeToEvents();
    this.menuBuilder.setup();
  }

  ngOnDestroy(): void {
    this.unsubscribeAll$.next();
    this.unsubscribeAll$.complete();
  }

  onClick(item: ProfileMenuItem): void {
    item.action();
  }

  onCloseMenu(): void {
    if (!this.profileMenuSidebar) {
      return;
    }
    this.profileMenuSidebar.close();
  }

  private subscribeToProfileMenuSidebar(): void {
    this.sidebarService
      .getSidebar(SidebarId.ProfileMenu)
      .pipe(takeUntil(this.unsubscribeAll$))
      .subscribe((sidebar) => (this.profileMenuSidebar = sidebar));
  }

  private subscribeToEvents(): void {
    this.eventsService.requestLogout$
      .pipe(takeUntil(this.unsubscribeAll$))
      .subscribe(() => this.authService.logout());

    this.eventsService.requestCompanyChange$
      .pipe(takeUntil(this.unsubscribeAll$))
      .subscribe(() =>
        this.userService.changeCompany({
          isSaveCurrentRoute: true,
        })
      );

    this.eventsService.showMyProfile$
      .pipe(takeUntil(this.unsubscribeAll$))
      .subscribe(() => this.router.navigate(['user-profile']));

    this.service.dataChanged$
      .pipe(takeUntil(this.unsubscribeAll$))
      .subscribe(() => this.changeDetectorRef.detectChanges());
  }
}
